<template>
  <b-container fluid>
    <b-row
      class="mt-2"
      v-loading.fullscreen.lock="fullScreenLoading"
      element-loading-text="loading..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <b-col>
        <b-card>
          <!--基础信息-->
          <!-- <div style="font-size: 14px; color: #606266">
            <span>No：{{ formData.fabricStockOutNo }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>Status：{{ formData.fabricStockOutStatusName }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>
              Create：{{ formData.createByName }} at
              {{ formData.createDate }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span>
              Modify：{{ formData.modifyByName }} at
              {{ formData.modifyDate }}
            </span>
          </div> -->
          <el-row :gutter="10">
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
              <span class="group-title"
                >No：{{ formData.fabricStockOutNo }}</span
              >
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
              <span class="group-title"
                >Status：{{ formData.fabricStockOutStatusName }}</span
              >
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
              <span class="group-title"
                >Create：{{ formData.createByName }} at
                {{ formData.createDate }}</span
              >
            </el-col>
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 6 }">
              <span class="group-title"
                >Modify：{{ formData.modifyByName }} at
                {{ formData.modifyDate }}</span
              >
            </el-col>
          </el-row>
          <div class="d2-mt">
            <el-form ref="formData" :model="formData" :rules="rules">
              <el-row :gutter="20">
                <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                  <el-form-item :label="'申请人'" prop="requestAgentName">
                    <el-input
                      readonly
                      v-model="formData.requestAgentName"
                      :placeholder="'请输入...'"
                      clearable
                      size="small"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                  <el-form-item :label="'申请日期'" prop="requestDate">
                    <el-date-picker
                      readonly
                      clearable
                      v-model="formData.requestDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      size="small"
                      :placeholder="'请选择...'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
                  <el-form-item :label="'出库日期'" prop="outStockDate">
                    <el-date-picker
                      readonly
                      clearable
                      v-model="formData.outStockDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      size="small"
                      :placeholder="'请选择...'"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item :label="'面料用途'" prop="requestUse">
                    <el-input
                      readonly
                      v-model="formData.requestUse"
                      :placeholder="'请输入...'"
                      maxlength="4000"
                      clearable
                      size="medium"
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 3 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-form-item :label="'备注说明'" prop="outStockMemo">
                    <el-input
                      readonly
                      v-model="formData.outStockMemo"
                      :placeholder="'请输入...'"
                      clearable
                      size="medium"
                      maxlength="4000"
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 3 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div>
              <detail-data ref="detailData" readonly :tableData="tableData" />
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <el-dialog :title="'提示信息'" :visible.sync="dialogVisible" width="30%">
      <span>{{ '是否要保存更改?' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">{{
          '取消'
        }}</el-button>
        <el-button @click="back()" size="small">{{ '不保存' }}</el-button>
        <el-button type="primary" @click="backSave()" size="small">{{
          '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </b-container>
</template>
<script>
import validate from '@/libs/util.validate'
import DetailData from './components/list.vue'
export default {
  components: {
    DetailData,
  },
  data() {
    return {
      fullScreenLoading: false,
      params: {
        fabricStockOutCode: '',
      },
      pageHeader: '',
      dialogVisible: false,
      disabled: false,
      tableData: [],
      formData: {
        fabricStockOutCode: '',
        fabricStockOutNo: '',
        requestAgentCode: '',
        requestAgentName: '',
        requestAgentDeptCode: '',
        requestAgentDeptName: '',
        requestUse: '',
        requestDate: '',
        outStockDate: '',
        outStockMemo: '',
        companyCode: '',
        fabricStockOutStatus: '',
        fabricStockOutStatusName: '',
        createBy: '',
        createByName: '',
        createDate: '',
        modifyBy: '',
        modifyByName: '',
        modifyDate: '',
        auditBy: '',
        auditByName: '',
        auditDate: '',
      },
      type: '',
      rules: {
        requestAgentCode: [
          {
            required: true,
            message: '请选择申请人',
            trigger: 'blur',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'blur',
          },
        ],
        outStockDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_date') || '选择日期',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    if (this.$route.params.fabricStockOutCode) {
      let fabricStockOutCode = this.$route.params.fabricStockOutCode
      this.init(fabricStockOutCode)
    }
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },
  activated() {
    if (this.$route.params.fabricStockOutCode) {
      let fabricStockOutCode = this.$route.params.fabricStockOutCode
      this.init(fabricStockOutCode)
    }
  },
  methods: {
    init(fabricStockOutCode) {
      this.reset()
      this.detailLoad(fabricStockOutCode)
    },

    detailLoad(fabricStockOutCode) {
      this.pageHeader = '面料领用出库详情'
      this.disabled = true
      let param = { fabricStockOutCode: fabricStockOutCode }
      this.loadData(param)
    },
    loadData(param) {
      this.fullScreenLoading = true
      this.$api
        .opaFabricStockOutDetailApi(param)
        .then((res) => {
          this.fullScreenLoading = false
          this.formData = res.body
          this.tableData = res.body.listDetail
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    addLoad() {
      this.pageHeader = '面料领用出库新增'
      this.disabled = false
    },
    save() {
      const form = this.$refs.formData
      const getDetailData = this.$refs.detailData.getTableData()
      if (getDetailData.length < 1) {
        this.$message.warning('请选择库存面料')
        return false
      }
      try {
        getDetailData.forEach((item, index) => {
          let requestQuantity = parseFloat(item.requestQuantity)
          let outQuantity = parseFloat(item.outQuantity)
          let rowNumber = index + 1
          if (outQuantity === 0) {
            let msg = '第【' + rowNumber + '】行，出库数量等于0'
            throw new Error(msg)
          }
          if (requestQuantity < outQuantity) {
            let msg = '第【' + rowNumber + '】行，出库数量大于库存数量'
            throw new Error(msg)
          }
        })
      } catch (e) {
        this.$message.warning(e.message)
        return
      }
      this.formData.listDetail = getDetailData
      validate.formValidate([form], (valid) => {
        if (valid) {
          this.fullScreenLoading = true
          this.$api
            .fabricStockOutSaveApi(this.formData)
            .then(() => {
              this.fullScreenLoading = false
              this.$message.success('保存成功!')
              this.back()
            })
            .catch(() => {
              this.fullScreenLoading = false
            })
        }
      })
    },
    backSave() {
      this.dialogVisible = false
      this.save()
    },
    back() {
      history.back()
      this.dialogVisible = false
      this.reset()
    },
    reset() {
      this.$refs.formData.resetFields()
      this.type = ''
      this.dialogVisible = false
      this.formData = {
        fabricStockOutNo: '',
        requestAgentName: '',
        requestAgentDeptName: '',
        requestUse: '',
        requestDate: '',
        outStockDate: '',
        outStockMemo: '',
        fabricStockOutStatus: '',
        fabricStockOutStatusName: '',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: '',
        auditBy: '',
        auditByName: '',
        auditDate: '',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
.el-form-item {
  margin-bottom: 5px !important;
}
</style>
